import { Injectable } from '@angular/core';
import { AssetsGenerateUrlService, AssetUIModel } from '@thehubz/client/core';
import { Collection } from '@thehubz/client/data-access-api';

@Injectable()
export class CollectionAssetPreviewService {
  constructor(private assetUrlService: AssetsGenerateUrlService) {}

  /**
   * Generate the cover preview
   * @returns
   */
  async generateCoverPreview(collectionList: Collection[]) {
    return Promise.all(
      collectionList.map(async (collection) => {
        const collectionCover = collection.coverAssetID ? this.assetUrlService.addPreviewUrl(collection.coverAssetID as unknown as AssetUIModel) : null;
        return {
          ...collection,
          coverAssetID: collectionCover,
        };
      }),
    );
  }
}
